module.exports = __webpack_public_path__ + "img/4-8.476d69e1.png";